import { useSyncExternalStore } from 'react';
import i18n from './index';

const subscribe = (onLanguageChanged: () => void) => {
  i18n.on('languageChanged', onLanguageChanged);

  return () => i18n.off('languageChanged', onLanguageChanged);
};

const getLanguage = () => i18n.language;

// Returns the active language tag and re-renders the caller when it changes.
//
// Use this instead of useTranslation in components that need the language but not the
// t function — most importantly in memoized components. A memoized component whose
// output depends on the language (date formatting, number formatting) but whose props
// don't mention it will never re-render on a language switch, because memo sees
// identical props and bails out. Subscribing here gives the component its own update,
// which memo cannot block.
//
// It is also much cheaper per render than useTranslation, which rebuilds a copy of the
// whole i18n instance on every language change — that matters when the hook runs once
// per table cell.
export const useAppLanguage = () => useSyncExternalStore(subscribe, getLanguage, getLanguage);
